import { MenuItem, MenuItems } from "../../../../common/AppSidebar/types";

export const findItemById = (items: MenuItems, id: string): MenuItem | null => {
  for (const item of items) {
    if (item.id === id) return item;
    if (item.children?.length) {
      const found = findItemById(item.children, id);
      if (found) return found;
    }
  }
  return null;
};
